import CryptoJS from 'crypto-js';
import classNames from 'classnames/bind';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Loading from '../Loading';
import CusButton from '../CusButton';
import { convertCurrency } from '~/configs';
import ResultPayment from '../ResultPayment';
import styles from './FormPayment.module.scss';
import { isValidFormPayment } from './validation';
import { requestPlayerPayment } from '~/services/payment';
import { dispatchPostError } from '~/redux/reducer/error';
import { logoutAccountSuccess } from '~/redux/reducer/auth';
import { actionSelectAward } from '~/redux/reducer/payment';

const cx = classNames.bind(styles);

const secretKeyPostCharging = 'thegioicode_secret_key_charging_napthe';

function FormPayment() {
    const [code, setCode] = useState('');
    const [serial, setSerial] = useState('');
    const [loading, setLoading] = useState(false);
    const [paymentError, setPaymentError] = useState('');
    const [activeResult, setActiveResult] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const ref = queryParams.get('ref');

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.auth);
    const { paymentSelected, awardSelected } = useSelector((state) => state.payment);

    useEffect(() => {
        if (!paymentSelected || !awardSelected) {
            navigate('/app');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentSelected, awardSelected]);

    useEffect(() => {
        if (activeResult) {
            setCode('');
            setSerial('');
            setActiveResult(false);
        }

        setPaymentError('');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentSelected]);

    const handleConfirmPayment = async () => {
        if (!isValidFormPayment(serial)) {
            return setPaymentError('Serial thẻ không đúng định dạng');
        }

        if (!isValidFormPayment(code)) {
            return setPaymentError('Mã thẻ không đúng định dạng');
        }

        setLoading(true);

        if (ref && ref === 'billing') {
            setTimeout(() => {
                setLoading(false);
                setActiveResult(true);
            }, 3000);

            return;
        }

        // Mã hóa các dữ liệu
        const encryptedCode = CryptoJS.AES.encrypt(code, secretKeyPostCharging).toString();
        const encryptedSerial = CryptoJS.AES.encrypt(serial, secretKeyPostCharging).toString();
        const encryptedTelco = CryptoJS.AES.encrypt(paymentSelected.code, secretKeyPostCharging).toString();
        const encryptedAmount = CryptoJS.AES.encrypt(String(awardSelected.amount.value), secretKeyPostCharging).toString();

        const data = {
            code: encryptedCode,
            telco: encryptedTelco,
            amount: encryptedAmount,
            serial: encryptedSerial,
        };

        const result = await requestPlayerPayment(data);

        setLoading(false);
        if (result.error) {
            return setPaymentError(result.error);
        }

        if (result.status === 403) {
            dispatch(logoutAccountSuccess());
            localStorage.removeItem('_re');
            navigate('/');
            window.location.reload();
        } else if (result.status === 401) {
            dispatch(dispatchPostError(result));
        } else {
            setActiveResult(true);
        }
    };

    const handlePaymentBack = () => {
        setActiveResult(false);
        dispatch(actionSelectAward(null));
    };

    return (
        <div className={cx('wrapper')}>
            {loading && !activeResult && <Loading height="50" />}

            {!loading && !activeResult && (
                <div className={cx('container')}>
                    <div className={cx('title')}>Chi tiết giao dịch</div>

                    <div className={cx('content')}>
                        <div className={awardSelected?.type === 'membership' ? cx('line', 'active') : cx('line')}>
                            <div className={cx('product')}>Sản phẩm được chọn</div>

                            <div className={cx('value')}>
                                <img
                                    src={
                                        awardSelected?.type === 'award'
                                            ? currentUser?.app.bonus_icon
                                            : awardSelected?.type === 'membership'
                                            ? awardSelected?.bonus_icon
                                            : ''
                                    }
                                    alt={currentUser?.app.title}
                                />

                                <span>{awardSelected?.title}</span>
                            </div>
                        </div>

                        {awardSelected?.type === 'membership' && (
                            <Fragment>
                                <div className={cx('description')}>{awardSelected?.description}</div>
                                <div className={cx('line', 'not')}></div>
                            </Fragment>
                        )}

                        <div className={cx('line')}>
                            <div className={cx('product')}>Giá</div>

                            <div className={cx('value')}>{convertCurrency(awardSelected?.amount.value)}</div>
                        </div>
                        <div className={cx('line')}>
                            <div className={cx('product')}>Phương thức thanh toán</div>
                            <div className={cx('value')}>{paymentSelected?.title}</div>
                        </div>
                        <div className={cx('line')}>
                            <div className={cx('product')}>Tên tài khoản trong game</div>
                            <div className={cx('value')}>{currentUser?.nickname || currentUser?.username}</div>
                        </div>
                        <div className={cx('line', 'active')}>
                            <div className={cx('product')}>Serial thẻ</div>
                        </div>
                        <div className={cx('code')}>
                            <input
                                type="text"
                                placeholder="Nhập serial thẻ của bạn"
                                value={serial}
                                onChange={(e) => {
                                    setPaymentError('');
                                    setSerial(e.target.value);
                                }}
                            />
                        </div>
                        <div className={cx('line', 'active')}>
                            <div className={cx('product')}>Mã thẻ</div>
                        </div>
                        <div className={cx('code')}>
                            <input
                                type="text"
                                placeholder="Nhập mã thẻ của bạn"
                                value={code}
                                onChange={(e) => {
                                    setPaymentError('');
                                    setCode(e.target.value);
                                }}
                            />
                        </div>

                        {paymentError && <div className={cx('valid')}>{paymentError}</div>}

                        <div className={cx('btn-confirm')}>
                            <CusButton onClick={handleConfirmPayment} text="Xử lý thanh toán" />
                        </div>
                    </div>
                </div>
            )}

            {activeResult && !loading && <ResultPayment handlePaymentBack={handlePaymentBack} refs={`/${ref}`} />}
        </div>
    );
}

export default FormPayment;
